<div
  #container
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
>
  <ng-content> </ng-content>
</div>
@if (isNavigationAllowed && showDots) {
  <div class="dots-container">
    @for (data of dots(); track $index; let i = $index) {
      <div
        class="dot"
        [ngClass]="{ square: isSquare }"
        [class.active]="i === activeTabIndex()"
        (click)="goToSlide(i)"
      ></div>
    }
  </div>
}
